import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/budget-forecast")({
  staticData: { title: "Budget Forecast" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/budget-forecast/page.tsx"),
    "BudgetForecast",
  ),
})
